import {createButtonComponent, IButtonProperties, IButtonBusinessLogic} from '@vfde-brix/button';

/**
 * Export mountButton
 *
 * @export mountButton
 */
export const mountSubmitButton = (target, submitButtonText, action) => {

    const buttonBusinessLogic: IButtonBusinessLogic = {
        onClick: action,
    };

    const props: IButtonProperties = {
        content: submitButtonText,
        optWidthVariation: 'auto',
        optColor: 'strong',
        optShape: 'rectangle',
        size: 'large',
        business: buttonBusinessLogic,
    };

    return createButtonComponent(target, props);

};
